module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapping-modal"
  }, [_c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        return _vm.reset()
      },
      "ok": function($event) {
        return _vm.submitData()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pilih Topik: "), (_vm.selectedCard !== null) ? _c('strong', [_vm._v(_vm._s(_vm.selectedCard.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "input-group m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukan kata kunci pencarian ..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), (_vm.filteredCards.length === 0 && _vm.selectedCard !== null) ? _c('p', [_vm._v("Tidak ada data lagi di bawah topik ini")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredCards), function(card, index) {
    return _c('button', {
      key: index,
      staticClass: "btn btn-lg btn-inverse btn-block col-md-12 p-10",
      on: {
        "click": function($event) {
          return _vm.onCardSelected(card)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "50px",
        "align": "left"
      },
      attrs: {
        "src": card.picture
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(card.name))])])
  })], 2)]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a42e7922","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kodifikasi/MappingModal.vue
// module id = 1383
// module chunks = 0